"use client";

import type { LogsEvent } from "@datadog/browser-logs";
import { datadogLogs } from "@datadog/browser-logs";
import {
  APP_VERSION,
  DATADOG_CLIENT_TOKEN,
  DATADOG_ENV,
  DATADOG_SERVICE,
  DATADOG_SESSION_SAMPLE_RATE,
  DATADOG_SITE
} from "config";

const beforeSend = (event: LogsEvent) => {
  const IGNORE_ERRORS: string[] = [
    "NEXT_HTTP_ERROR_FALLBACK;404",
    "[OPTIMIZELY LOGGER]: INDEX_BROWSER: unable to bind optimizely.close()",
    "[OPTIMIZELY LOGGER]: PROJECT_CONFIG: Experiment ID",
    "OPTIMIZELY",
    "TypeError: Cannot create property '__NA' on string"
  ];
  return !(
    IGNORE_ERRORS.includes(event.error?.message || "") ||
    event.view.url.includes("devNotes")
  );
};

datadogLogs.init({
  clientToken: DATADOG_CLIENT_TOKEN || "",
  site: DATADOG_SITE,
  env: DATADOG_ENV,
  service: DATADOG_SERVICE,
  version: APP_VERSION,
  sessionPersistence: "local-storage",
  forwardErrorsToLogs: true,
  forwardConsoleLogs: ["error", "debug"],
  sessionSampleRate: DATADOG_SESSION_SAMPLE_RATE,
  beforeSend
});

export default function DatadogLogsInit() {
  // Render nothing - this component is only included so that the init code
  // above will run client-side
  return null;
}
